// Enrollment progress. Four separate confirmation steps: Application
// details, Written acceptance, Qualifying period, Active coverage.
// Each step has independent completion state; this view does not approve
// enrollment.
//
// TODO(runtime): hydrate state from services/customer-coverage (coverage
// assignment table) + dist/account-workflows.applications status fields.
import type { ReactNode } from 'react';
import type { EnrollmentStep } from '../mockData.js';

export interface EnrollmentStepsProps {
  steps: EnrollmentStep[];
}

export function EnrollmentSteps({ steps }: EnrollmentStepsProps): ReactNode {
  return (
    <section className="card enrollment-card">
      <div className="section-heading">
        <h3>Enrollment progress</h3>
        <span>Separate confirmations</span>
      </div>
      <div className="enrollment-steps">
        {steps.map((step) => (
          <article
            key={step.index}
            className={step.state === 'incomplete' ? 'step-incomplete' : undefined}
          >
            <span>{step.index}</span>
            <strong>{step.title}</strong>
            <small>{step.detail}</small>
          </article>
        ))}
      </div>
      <p className="steps-note">
        Program rules determine the requirements and timing. This view does not approve enrollment.
      </p>
    </section>
  );
}
